import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type { SocialAccount } from './types';

interface SocialMediaState {
  accounts: SocialAccount[];
  hasLoaded: boolean;
}

const initialState: SocialMediaState = {
  accounts: [],
  hasLoaded: false,
};

const socialMediaSlice = createAppSlice({
  name: 'socialMedia',
  initialState,
  reducers: {
    // Atomically writes the accounts list and flips the "has loaded" gate (CLAUDE.md rule 8).
    setSocialAccounts: (state, action: PayloadAction<SocialAccount[]>) => {
      state.accounts = action.payload;
      state.hasLoaded = true;
    },
    socialMediaReset: () => initialState,
  },
});

export const { setSocialAccounts, socialMediaReset } = socialMediaSlice.actions;
export default socialMediaSlice.reducer;
